'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
var _validateIf = require('../validate-if');
var _validateIf2 = _interopRequireDefault(_validateIf);
var _isAlphanumerical = require('../is-alphanumerical');
var _isAlphanumerical2 = _interopRequireDefault(_isAlphanumerical);
var _oneOf = require('../one-of');
var _oneOf2 = _interopRequireDefault(_oneOf);
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}
exports.default = function (statusOptions) {
  var allowable = statusOptions.map(function (option) {
    return option.value;
  });
  var captureExtraData = statusOptions.filter(function (option) {
    return option.captureExtraData === '1';
  }).map(function (option) {
    return option.value;
  });
  return {
    employmentStatus: (0, _oneOf2.default)(allowable, 'Please could you tell us your employment status'),
    occupation: (0, _validateIf2.default)(function (_, values) {
      return !!~captureExtraData.indexOf(values.employmentStatus);
    }, (0, _isAlphanumerical2.default)('Please start typing your occupation and select from the list provided')),
    industry: (0, _validateIf2.default)(function (_, values) {
      return !!~captureExtraData.indexOf(values.employmentStatus);
    }, (0, _isAlphanumerical2.default)('Please start typing your industry and select from the list provided'))
  };
};